import { FlightShopStep } from "redmond";
var CORE_FLIGHTS_SHOP_ROUTES = {
    SHOP_ROUTE: "shop",
    RETURN_ROUTE: "return",
    REVIEW_ROUTE: "review",
    REVIEW_FARE_ROUTE: "fare",
};
export var getCoreFlightsShopSubPath = function (flightShopStep) {
    switch (flightShopStep) {
        case FlightShopStep.ChooseDeparture:
            return "";
        case FlightShopStep.ChooseReturn:
            return "".concat(CORE_FLIGHTS_SHOP_ROUTES.RETURN_ROUTE, "/");
        case FlightShopStep.ReviewItinerary:
            return "".concat(CORE_FLIGHTS_SHOP_ROUTES.REVIEW_ROUTE, "/");
        case FlightShopStep.FareDetails:
            return "".concat(CORE_FLIGHTS_SHOP_ROUTES.REVIEW_ROUTE, "/").concat(CORE_FLIGHTS_SHOP_ROUTES.REVIEW_FARE_ROUTE, "/");
        default:
            return "";
    }
};
export var CoreFlightsSearchQueryParams;
(function (CoreFlightsSearchQueryParams) {
    CoreFlightsSearchQueryParams["ORIGIN"] = "origin";
    CoreFlightsSearchQueryParams["ORIGIN_REGION_TYPE"] = "originRegionType";
    CoreFlightsSearchQueryParams["DESTINATION"] = "destination";
    CoreFlightsSearchQueryParams["DESTINATION_REGION_TYPE"] = "destinationRegionType";
    CoreFlightsSearchQueryParams["DEPARTURE_DATE"] = "departureDate";
    CoreFlightsSearchQueryParams["RETURN_DATE"] = "returnDate";
    CoreFlightsSearchQueryParams["TRIP_CATEGORY"] = "tripCategory";
    CoreFlightsSearchQueryParams["STOPS_OPTION"] = "stopsOption";
    CoreFlightsSearchQueryParams["ADULT_COUNT"] = "adultsCount";
    CoreFlightsSearchQueryParams["CHILD_COUNT"] = "childrenCount";
    CoreFlightsSearchQueryParams["INFANT_IN_SEAT_COUNT"] = "infantsInSeatCount";
    CoreFlightsSearchQueryParams["INFANT_IN_LAP_COUNT"] = "infantsOnLapCount";
    CoreFlightsSearchQueryParams["NO_LCC"] = "noLCC";
    CoreFlightsSearchQueryParams["FARE_CLASS"] = "fareClass";
    CoreFlightsSearchQueryParams["IS_TRAVEL_APP"] = "isTravelApp";
    CoreFlightsSearchQueryParams["EXPANDED_FLIGHT_CARD"] = "expandedFlightCard";
    CoreFlightsSearchQueryParams["OPEN_FLIGHT_DETAILS_DIALOG"] = "openFlightDetailsDialog";
})(CoreFlightsSearchQueryParams || (CoreFlightsSearchQueryParams = {}));
//# sourceMappingURL=coreFlightsTypes.js.map